import React from "react";

import { faCheck } from "@fortawesome/pro-regular-svg-icons";

import { useDashboardQuery } from "src/api/analytics-dashboard/dashboard";
import { DisplayDateFromNow } from "src/base-components/Date";
import { Realm } from "src/clients/analytics-dashboard";
import { Pill } from "src/design-system/Pill";
import { UpdatedByInfo } from "src/flowContainer/versionEditedInfo/utils";

type Props = {
  realm: Realm;
  realmId: string;
  dashboardId?: string;
};

export const DashboardLastEditedInfo: React.FC<Props> = ({
  realm,
  realmId,
  dashboardId,
}) => {
  const { data } = useDashboardQuery(realm, realmId, dashboardId);

  if (!data?.updated_by || !data.updated_at) return null;

  return (
    <Pill dataLoc="dashboard-last-edited-info" size="sm" variant="gray">
      <Pill.Icon icon={faCheck} />
      <Pill.Text>
        Updated <DisplayDateFromNow value={data.updated_at} />{" "}
        <UpdatedByInfo updatedBy={data.updated_by} />
      </Pill.Text>
    </Pill>
  );
};
